import { orderAttributionByOrderIdSchema } from "@redotech/redo-marketing-common/order-attribution";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/** A request-size guard, well above the orders one transcript can load. */
const MAX_ORDERS = 500;

export const getOrderAttribution = {
  name: "getOrderAttribution" as const,
  input: z.object({
    orders: z
      .array(
        z.object({
          orderId: z.string().describe("Redo order id"),
          orderedAt: zExt.instant().describe("When the order was placed"),
          recordedAt: zExt
            .instant()
            .describe("When the order's event was saved"),
        }),
      )
      .min(1)
      .max(MAX_ORDERS),
  }),
  output: orderAttributionByOrderIdSchema,
};
